<template>
  <v-dialog v-model="editDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t('Edit Cashier information') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="headline no-select pb-1">
              <v-layout justify-end></v-layout>
            </v-flex>

            <v-layout row wrap>
              <v-flex xs12 sm12 md12 class="py-1 px-2">
                <v-text-field
                  v-model="cashierInfo.cashier_name"
                  :label="`${$t('Cashier Name')} *`"
                  name="Cashier Name"
                  hide-details
                  box
                  background-color="white"
                  :error="errors.has(' Cashier Name')"
                  v-validate="'required'"
                />
              </v-flex>

              <v-flex xs6 sm6 md6 class="py-1 px-2">
                <v-text-field
                  v-model="cashierInfo.amount_iq"
                  :label="`${$t('Amount')} (${systemCurrency})*`"
                  name="Amount"
                  hide-details
                  box
                  background-color="white"
                  :error="errors.has('Amount')"
                  v-validate="'required|numeric|min_value:1'"
                />
              </v-flex>
              <v-flex xs6 sm6 md6 class="py-1 px-2">
                <v-text-field
                  v-model="cashierInfo.begin_iq"
                  :label="`${$t('Begin')} (${systemCurrency}) *`"
                  name="Begin (IQD)"
                  hide-details
                  box
                  background-color="white"
                  :error="errors.has('Begin (IQD)')"
                  v-validate="'required|numeric|min_value:1'"
                />
              </v-flex>

              <v-flex xs6 sm6 class="pa-2">
                <v-menu offset-y full-width :close-on-content-click="false">
                  <v-text-field
                    slot="activator"
                    v-model="cashierInfo.start_time"
                    :label="$t('Start Time')"
                    prepend-inner-icon="schedule"
                    box
                    hide-details
                    name="start_time"
                    background-color="white"
                    autocomplete="off"
                  />
                  <v-time-picker v-model="time1" @input="formatStartTime(time1)" width="318" />
                </v-menu>
              </v-flex>
              <v-flex xs6 sm6 class="pa-2">
                <v-menu offset-y full-width :close-on-content-click="false">
                  <v-text-field
                    slot="activator"
                    v-model="cashierInfo.end_time"
                    :label="$t('End Time')"
                    prepend-inner-icon="schedule"
                    box
                    hide-details
                    background-color="white"
                    name="end_time"
                    autocomplete="off"
                  />
                  <v-time-picker v-model="time2" @input="formatEndTime(time2)" width="318" />
                </v-menu>
              </v-flex>

              <v-flex pa-2>
                <v-autocomplete
                  v-model="cashierInfo.outlet_id_fk"
                  :items="outletsList"
                  :label="`${$t('Outlet')} *`"
                  box
                  hide-details
                  :error="errors.has('Outlet')"
                  background-color="white"
                  v-validate="'required'"
                  data-vv-name="Outlet"
                  :menu-props="{ transition: 'slide-y-transition' }"
                />
              </v-flex>

              <v-flex xs1 pt-2 v-if="hasPermissions(['outlets_store'])">
                <v-tooltip top>
                  <v-btn label @click="dialogs.addOutlet = true" slot="activator" icon fab small color="green">
                    <v-icon color="white">add</v-icon>
                  </v-btn>
                  <span>{{ $t('Add new outlet') }}</span>
                </v-tooltip>
              </v-flex>

              <v-flex pa-2>
                <v-autocomplete
                  v-model="cashierInfo.user_id_fk"
                  :items="staffsList"
                  :label="`${$t('Staff')} *`"
                  box
                  hide-details
                  :error="errors.has('Staff')"
                  background-color="white"
                  v-validate="'required'"
                  data-vv-name="Staff"
                  :menu-props="{ transition: 'slide-y-transition' }"
                />
              </v-flex>

              <v-flex xs1 pt-2 v-if="hasPermissions(['users_store'])">
                <v-tooltip top>
                  <v-btn label @click="dialogs.addStaff = true" slot="activator" icon fab small color="green">
                    <v-icon color="white">add</v-icon>
                  </v-btn>
                  <span>{{ $t('Add new staff') }}</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>

    <add-outlet
      :addDialog="dialogs.addOutlet"
      @reset-datatable="setOutletsList()"
      @hidemodal="dialogs.addOutlet = false"
    />

    <add-staff
      :addDialog="dialogs.addStaff"
      @reset-datatable="setStaffsList()"
      @hidemodal="resetAllErrors(true), (dialogs.addStaff = false)"
    />
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import addOutlet from '@/views/preferences/outlets/addOutlet.vue'
import addStaff from '@/views/staff/staff/addStaff.vue'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  components: {
    addOutlet,
    addStaff
  },

  data() {
    return {
      dialogs: {
        addOutlet: false,
        addStaff: false
      },
      systemCurrency: localStorage.systemCurrency,
      btnUpdateLoading: false,
      form: {},
      time1: null,
      time2: null
    }
  },

  computed: {
    ...mapGetters({
      cashierInfo: 'cashiers/getCashierInfo',
      outletsList: 'outlets/getFullOutletsList',
      staffsList: 'staff/getFullStaffsList'
    })
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.addEscKeyListener()
        }
      }
    }
  },

  mounted() {
    this.setOutletsList()
    this.setStaffsList()
  },

  methods: {
    ...mapActions({
      updateCashierInfo: 'cashiers/updateCashierInfo',
      setOutletsList: 'outlets/setFullOutletsList',
      setStaffsList: 'staff/setFullStaffsList'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    formatStartTime(time) {
      this.cashierInfo.start_time = helpers.formatTimeForDisplay(time)
    },

    formatEndTime(time) {
      this.cashierInfo.end_time = helpers.formatTimeForDisplay(time)
    },

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the 'ESC' button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnUpdateLoading = true
            let formData = new FormData(event.target)
            formData.append('cashier_name', this.cashierInfo.cashier_name)
            formData.append('amount_iq', this.cashierInfo.amount_iq)
            formData.append('begin_iq', this.cashierInfo.begin_iq)
            formData.append('outlet_id_fk', this.cashierInfo.outlet_id_fk)
            formData.append('user_id_fk', this.cashierInfo.user_id_fk)

            let payload = { id: this.cashierInfo.cashier_id, formData }
            this.updateCashierInfo(payload)
              .then(() => {
                this.btnUpdateLoading = false
                this.$emit('updated')
              })
              .catch(() => {
                this.btnUpdateLoading = false
              })
          }
        })
        .catch(() => {
          this.btnUpdateLoading = false
        })
    }
  }
}
</script>

<style scoped></style>
